import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onBeforeUnmount, ref } from "vue";
import { ScanModalError } from "../errors";
import { SCAN_ERROR_MESSAGES } from "../../../../utils";
import { useCodeScannerAdapter } from "../../../../adapters/codeScannerAdapter";

// Template component ref

export default /*#__PURE__*/_defineComponent({
  emits: ["codeFound", "cameraEnabled"],
  setup(__props, { emit }: { emit: ({
  (event: "codeFound", code: string): void;
  (event: "cameraEnabled"): void;
}), expose: any, slots: any, attrs: any }) {

const videoContainer = ref<HTMLDivElement>();
const scannerVideoElement = ref<HTMLVideoElement>();

// events


const onCodeFound = (code: string) => {
  emit("codeFound", code);
};

const onCameraEnabled = () => {
  emit("cameraEnabled");
};

const { initScanner, resetScanner } = useCodeScannerAdapter(onCodeFound, onCameraEnabled);

onMounted(async () => {
  const isMediaStreamAPISupported = navigator && navigator.mediaDevices && "enumerateDevices" in navigator.mediaDevices;
  if (!isMediaStreamAPISupported) {
    throw new ScanModalError(SCAN_ERROR_MESSAGES.noCamera);
  }

  if (scannerVideoElement.value && videoContainer.value) {
    const videoHeight = videoContainer.value?.clientHeight;
    const videoWidth = videoContainer.value?.clientWidth;

    try {
      await initScanner(scannerVideoElement.value, videoWidth, videoHeight);
    } catch (error) {
      throw new ScanModalError(SCAN_ERROR_MESSAGES.noCamera);
    }
  }
});

onBeforeUnmount(() => {
  resetScanner();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "videoContainer",
    ref: videoContainer,
    class: "code-scanner__video-container"
  }, [
    _createElementVNode("video", {
      ref_key: "scannerVideoElement",
      ref: scannerVideoElement
    }, null, 512)
  ], 512))
}
}

})